<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-text.H1 {{ _('Якщо у Вас є діти віком до 12 місяців - дайте відповідь на декілька простих запитань і отримайте приємний сюрприз!') }}
    +b.poll-gift-decor.IMG(
      src='/static/images/gift.svg'
    )
    +b.poll-btn.BUTTON(
      href='',
      @click.prevent='next'
    ) {{ _('Почати') }}
  
</template>

<script>
export default {
  name: 'InitStep',
  methods: {
    next() {
      this.$emit("next", {
        current: 'AgeStep'
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/init.vue